import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ l.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M5.579 5.577a1.125 1.125 0 0 1 1.59 0l4.83 4.83 4.83-4.83a1.127 1.127 0 0 1 1.948.787 1.13 1.13 0 0 1-.358.803l-4.83 4.83 4.83 4.83a1.126 1.126 0 1 1-1.59 1.59l-4.83-4.83-4.83 4.83a1.125 1.125 0 0 1-1.59-1.59l4.83-4.83-4.83-4.83a1.125 1.125 0 0 1 0-1.59",
    fill: "currentColor"
  }
) });
export {
  s as C
};
